export default "__VITE_ASSET__DQTes7Fc__"